module.exports = __webpack_public_path__ + "img/icn-logout.b65d1ca6.svg";